import { CheckCircle, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import BgImage from "../../../assets/bg1.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



const SingleAudioDetails = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [activeTab, setActiveTab] = useState(1);
  const [disable, setDisable] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchAudioDetails();
  }, []);

  const fetchAudioDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.audioTable}/uploaded`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(res?.data?.data || []);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode) {
        if (statusCode === 401) {
          localStorage.clear();
        }
      } else {
        console.error("No error code received from the server");
      }
    }
  };

  const transcriptData = async (data) => {
    setDisable(true);
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig.transcript,
        [data],
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDisable(false);
      fetchAudioDetails();
    } catch (error) {
      setDisable(false);
      console.error("Error fetching audio details:", error);
    }
  };

  const handleSubmit = () => {
    transcriptData(data[0]);
  };
  return (
    <ParentWrapper>
      <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          p: 6,
          mt: {
            xs: 0,
            md: 1,
          },
        }}
      >
        {/* <CustomizedSteppers activeTab={activeTab} /> */}
        <Grid
          item
          md={12}
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <Box>
            {data.length == 0 ? (
              ""
            ) : (
              <Box
                sx={{
                  width: "100%",
                  mt: "70px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    border: "1px solid #EEEEEE",
                    borderRadius: 6,
                    overflowX: "auto",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>File Path</TableCell>
                        <TableCell>Uploading Status</TableCell>
                        <TableCell>Created At</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.fileName}</TableCell>
                            <TableCell>{row.filePath}</TableCell>
                            <TableCell
                              sx={{
                                color:
                                  row.uploadingStatus === "failed"
                                    ? "red"
                                    : row.uploadingStatus === "processing"
                                    ? "orange"
                                    : "green",
                              }}
                            >
                              {row.uploadingStatus}
                            </TableCell>
                            <TableCell>{row.createdAt}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ mt: 3, textAlign: "right" }}>
                  {disable == false ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      sx={{
                        textTransform: "capitalize",
                        borderRadius: "8px",
                        bgcolor: primary,
                        "&:hover": {
                          bgcolor: primary,
                        },
                      }}
                    >
                      Audio Transcript
                    </Button>
                  ) : (
                    <Button
                      disabled={true}
                      variant="contained"
                      color="primary"
                      sx={{
                        textTransform: "capitalize",
                        borderRadius: "8px",
                      }}
                    >
                      analysing &nbsp;&nbsp;
                      <CircularProgress size={20} />
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Box>
    </Box>
    </ParentWrapper>
  );
};

export default SingleAudioDetails;
